/* istanbul ignore file */
export { default } from './Modal';
